// Data to configure the various constellations
import { BodyConfig } from 'lib/types';
import {
	CLOUD,
	COUNT_BADGE,
	CUSTOMER_MEMBERS,
	PLUS_BADGE,
	DATA_BOX,
	PERSON,
	MARKETING,
	SALES,
	SERVICE,
	COMMERCE,
	COMMUNITY,
	MULESOFT,
	COMPANY,
	TABLE,
	SAPMOON
} from './data-source-icons';
const RADIUS = 64;
const MOON_MOON_RADIUS = 52;

//
// Center planets
//
export const sfCenter: BodyConfig = {
	name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD
};

export const dataCenter: BodyConfig = {
	name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX
};

export const personCenter: BodyConfig = {
	name: '', radius: RADIUS, color: '#0070D2', icon: PERSON
};

export const mulesoftCenter: BodyConfig = {
	name: 'MuleSoft', radius: RADIUS, color: '#DDDBDA', icon: MULESOFT,
	badge: PLUS_BADGE
};

export const configuredMulesoftCenter: BodyConfig = {
	name: 'MuleSoft', radius: RADIUS, color: '#032E61', icon: MULESOFT,
};

//
// Moon systems
//
export const unConfiguredStart: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	}
];

export const start2: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	},
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(1), configured: true
	}
];

export const start3: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#ED8B00',
		icon: MARKETING, badge: COUNT_BADGE(1), configured: true
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	},
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(1), configured: true
	}
];

export const start4: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#ED8B00',
		icon: MARKETING, badge: COUNT_BADGE(1), configured: true
	},
	{
		name: 'Commerce', radius: RADIUS, color: '#416437',
		icon: COMMERCE, badge: COUNT_BADGE(1), configured: true
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	}, 
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(1), configured: true
	},
];

export const start4Cooking: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#ED8B00',
		icon: MARKETING, badge: COUNT_BADGE(5), configured: true
	},
	{
		name: 'Commerce', radius: RADIUS, color: '#416437',
		icon: COMMERCE, badge: COUNT_BADGE(8), configured: true
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	}, 
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(3), configured: true
	},
];

export const start5: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#ED8B00',
		icon: MARKETING, badge: COUNT_BADGE(5), configured: true
	},
	{
		name: 'Commerce', radius: RADIUS, color: '#416437',
		icon: COMMERCE, badge: COUNT_BADGE(8), configured: true
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	},
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(3), configured: true
	},
	{
		name: 'MuleSoft', radius: RADIUS, color: '#032E61', rotation: 315,
		icon: MULESOFT, badge: COUNT_BADGE(1), configured: true
	},
];

export const configuredStart: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA',
		icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#ED8B00',
		icon: MARKETING, badge: COUNT_BADGE(3), configured: true
	},
	{
		name: 'Commerce', radius: RADIUS, color: '#416437',
		icon: COMMERCE, badge: COUNT_BADGE(6), configured: true
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA',
		icon: CLOUD, badge: PLUS_BADGE
	},
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(3), configured: true
	},
	{
		name: 'Sales', radius: RADIUS, color: '#00857D',
		icon: SALES, badge: COUNT_BADGE(1), configured: true
	}
];

export const configuredMulesoftStart: BodyConfig[] = [
	{
		name: 'Other Data', radius: RADIUS, color: '#DDDBDA', icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#ED8B00',
		icon: MARKETING, badge: COUNT_BADGE(1), configured: true
	},
	{
		name: 'Commerce', radius: RADIUS, color: '#416437',
		icon: COMMERCE, badge: COUNT_BADGE(1), configured: true
	},
	{
		name: 'Salesforce Data', radius: RADIUS, color: '#DDDBDA', icon: CLOUD, badge: PLUS_BADGE
	},
	{
		name: 'Service', radius: RADIUS, color: '#812244',
		icon: SERVICE, badge: COUNT_BADGE(1), configured: true
	},
	{
		name: 'MuleSoft', radius: RADIUS, color: '#032E61', rotation: 315,
		icon: MULESOFT, badge: COUNT_BADGE(1), configured: true
	}
];

export const unConfiguredData: BodyConfig[] = [
	{
		name: 'Back >', radius: RADIUS, color: '#0070D2', icon: PERSON
	},
	{
		name: 'Marketing', radius: RADIUS, color: '#DDDBDA', icon: MARKETING, badge: PLUS_BADGE
	},
	{
		name: 'Commerce', radius: RADIUS, color: '#DDDBDA', icon: COMMERCE, badge: PLUS_BADGE
	},
	{
		name: 'Community', radius: RADIUS, color: '#DDDBDA', icon: COMMUNITY, badge: PLUS_BADGE
	},
	{
		name: 'Sales', radius: RADIUS, color: '#DDDBDA', icon: SALES, badge: PLUS_BADGE
	},
	{
		name: 'Service', radius: RADIUS, color: '#DDDBDA', icon: SERVICE, badge: PLUS_BADGE
	}
];

export const noMulesoftData: BodyConfig[] = [
	{
		name: '< Back', radius: RADIUS, color: '#DDDBDA', rotation: 180,
		icon: DATA_BOX
	}
];

export const noMulesoftDataBrunello: BodyConfig[] = [
	{
		name: '< Back', radius: RADIUS, color: '#0070D2', rotation: 180,
		icon: PERSON
	},
	{
		name: 'MuleSoft', radius: RADIUS, color: '#DDDBDA', rotation: 330,
		icon: MULESOFT, badge: PLUS_BADGE
	},
	{
		name: 'Add More', radius: RADIUS, color: '#DDDBDA', rotation: 30,
		icon: DATA_BOX, badge: PLUS_BADGE
	},

];

export const withMemberData: BodyConfig[] = [
	{
		name: '< Back', radius: RADIUS, color: '#DDDBDA', rotation: 180,
		icon: DATA_BOX
	},
	{
		name: 'Customer Members...', radius: RADIUS, color: '#DDDBDA', rotation: 330,
		icon: CUSTOMER_MEMBERS
	},
	{
		name: 'Add More', radius: RADIUS, color: '#DDDBDA', rotation: 30,
		icon: DATA_BOX, badge: COUNT_BADGE(3)
	},
];

export const withTwoAPIs: BodyConfig[] = [
	{
		name: 'Add More', radius: RADIUS, color: '#DDDBDA', rotation: 0,
		icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: '< Back', radius: RADIUS, color: '#DDDBDA', rotation: 180,
		icon: DATA_BOX
	},
	{
		name: 'Inventory Process...', radius: RADIUS, color: '#DDDBDA', rotation: 90,
		icon: TABLE
	},
	{
		name: 'Order Process...', radius: RADIUS, color: '#DDDBDA', rotation: 270,
		icon: COMPANY
	},
];

export const withThreeAPIs: BodyConfig[] = [
	{
		name: 'Add More', radius: RADIUS, color: '#DDDBDA', rotation: 0,
		icon: DATA_BOX, badge: PLUS_BADGE
	},
	{
		name: '< Back', radius: RADIUS, color: '#DDDBDA', rotation: 180,
		icon: DATA_BOX
	},
	{
		name: 'Inventory Process...', radius: RADIUS, color: '#DDDBDA', rotation: 90,
		icon: TABLE
	},
	{
		name: 'Order Process...', radius: RADIUS, color: '#DDDBDA', rotation: 235,
		icon: COMPANY
	},
	{
		name: 'Unique Customer...', radius: RADIUS, color: '#DDDBDA', rotation: 305,
		icon: CUSTOMER_MEMBERS
	},
];

export const withPOSData: BodyConfig[] = [
	{
		name: '< Back', radius: RADIUS, color: '#0070D2', rotation: 180,
		icon: PERSON
	},
	{
		name: 'MuleSoft', radius: RADIUS, color: '#032E61', rotation: 330,
		icon: MULESOFT, configured: true, badge: PLUS_BADGE,
		moons: [
			{
				name: 'SAP...', configured: true, radius: MOON_MOON_RADIUS, 
				color: '#DDDBDA', rotation: 300, icon: SAPMOON
			},
		]
	},
	{
		name: 'Add More', radius: RADIUS, color: '#DDDBDA', rotation: 30,
		icon: DATA_BOX, badge: PLUS_BADGE
	},
];



// WEBPACK FOOTER //
// ./src/data/constellations.ts